<template>
  <CFooter :fixed="false">
    <div id="pagetop" style="" @click="scrollToTop">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#4a5568"
        stroke-width="1"
        stroke-linecap="square"
        stroke-linejoin="arcs"
      >
        <path d="M18 15l-6-6-6 6"></path>
      </svg>
    </div>

    <div>
      <a href="#" target="_blank">ScanCom</a>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }}.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="#">Idea App</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: "TheFooter",
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
#pagetop {
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  background: hsla(0, 0%, 87.1%, 0.43137);
  cursor: pointer;
}
</style>